// 权限工具类

import store from "../vuex/index";
var AuthorityUtil = {
  // 	checkAuthority: function(value) {
  // 		var btn = value.split(":");
  // 		var checkBtn = store.state.userInfo.mapInfo.userFunction[btn[0]].sysFnBtnRel.find(function(obj) {
  // 			return obj.btnValue === btn[1]
  // 		})
  // 		if (checkBtn != undefined) {
  // 			return true
  // 		} else {
  // 			return false
  // 		}

  // // 		if (store.state.userInfo.page != 'admin') {
  // // 			if (store.state.userInfo.mapInfo.userFunction[btn[0]] == undefined) {
  // // 				return false
  // // 			} else {
  // // 				return store.state.userInfo.mapInfo.userFunction[btn[0]].rpfBns.indexOf(btn[1]) != -1
  // // 			}
  // //
  // // 		} else {
  // // 			var checkBtn = store.state.userInfo.mapInfo.userFunction[btn[0]].sysFnBtnRel.find(function(obj) {
  // // 				return obj.btnValue === btn[1]
  // // 			})
  // // 			if (checkBtn != undefined) {
  // // 				return true
  // // 			} else {
  // // 				return false
  // // 			}
  // // 		}
  // 	}
  /**
   * 判断按钮是否有权限
   */
  checkAuthority: function(value) {
    var btn = value.split(":"); // 获取有权限的按钮
    var checkBtn = store.state.userInfo.mapInfo.userFunction[btn[0]].rpfBns;
    // console.log(checkBtn)
    if (checkBtn != "" && checkBtn != null) {
      let list = checkBtn.split(",");
      for (let i = 0; i < list.length; i++) {
        if (list[i] == btn[1]) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }
};
export default AuthorityUtil;



// WEBPACK FOOTER //
// ./src/utils/AuthorityUtil.js